import { ICreateSaidaPUseCase } from "../../../presentation/useCases/create/create_saida_produtos_use_case";
import { IEstoqueRepository } from "../../repositories/estoque_repository";


export class CreateSaidaPUseCase implements ICreateSaidaPUseCase {
  constructor(private readonly repository: IEstoqueRepository) {}

  async createSaidaP( Data?: Date | null, IdCentroCusto?: number | null, IdCentroCustoDestino?: number | null, IdProdutoServico?: number | null, NroNotaFiscal?: string | null, Quantidade?: number | null, IdFornecedor?: number | null, IdFuncionario?: number | null, NrNotaFiscal?: string | null, IdSessaoMultipla?: string | null, Delete?: boolean | null, ValorUnitario?: number | null, localAplicacao?: string | null): Promise<number> {
    
    const response  = await this.repository.createSaidaP(
    Data, IdCentroCusto, IdCentroCustoDestino, IdProdutoServico, NroNotaFiscal, Quantidade, IdFornecedor, IdFuncionario, NrNotaFiscal, IdSessaoMultipla, Delete, ValorUnitario, localAplicacao
    );
    
    return response.IdSaidaProduto;
  }
}
